import { SVGProps } from 'react';

export const PhoneIconWithFill = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    {...props}
    aria-hidden="true"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.2923 15.84C21.2322 15.7923 16.8667 12.6456 15.6684 12.8715C15.0964 12.9727 14.7693 13.3628 14.113 14.1438C14.0074 14.2699 13.7537 14.5721 13.5564 14.7869C13.1416 14.6516 12.737 14.487 12.3457 14.2941C10.3257 13.3107 8.69366 11.6787 7.71027 9.65873C7.5173 9.26744 7.35261 8.86283 7.21747 8.448C7.43307 8.25 7.7352 7.99627 7.86427 7.88773C8.6416 7.23507 9.03247 6.908 9.13367 6.33453C9.3412 5.14653 6.19667 0.750933 6.16367 0.711333C6.021 0.507519 5.8348 0.337966 5.61856 0.214942C5.40232 0.0919187 5.16143 0.0185007 4.91333 0C3.6388 0 0 4.72047 0 5.5154C0 5.5616 0.0667334 10.2579 5.85787 16.1487C11.7429 21.9333 16.4384 22 16.4846 22C17.2803 22 22 18.3612 22 17.0867C21.9817 16.8394 21.9087 16.5994 21.7863 16.3838C21.664 16.1682 21.4952 15.9824 21.2923 15.84Z"
      fill="#464646"
    />
  </svg>
);
